{
  const globals = require('./Globals');
  const Logger = require('./Logger');
  // ### Description
  // Cookie utility class for managing cookies
  // consolidate/cleanup cookie functionality
  // http://www1.macys.com/javascript/cookieJar.js and
  // http://www1.macys.com/web20/assets/script/macys/./cookie-min.js
  // and http://www1.macys.com/web20/assets/script/yahoo/cookie/cookie-beta-min.js
  // and http://www1.macys.com/web20/assets/script/macys/base/cmFunctions.js
  // cookie and store up to 4K
  // Group cookies; decrease time to access groups in cookie
  // macys.com cookie reference on confluence
  // http://confluence/display/WDS/current+macys+cookies

  // ###constants
  // description of cookie constants to follow
  // example
  const MVC_SEPARATOR = '3_87_';
  const MVC_EQUATOR = '1_92_';
  const MVC_EMPTY_STRING = '4_02_';
  const path = '/';
  let expires = null;
  let secure = true;
  const Cookie = {};

  // we want to decode the data in the cookie
  // but we want to call this only once
  // this is for browsers that do not have decodeURIComponent
  if (typeof window.decodeURIComponent === 'undefined') {
    window.decodeURIComponent = typeof window.decodeURI === 'undefined' ? window.unescape : window.decodeURI;
  }

  // we want to encode the data in the cookie
  // but we want to call this only once
  // this is for browsers that do not have encodeURLComponent
  if (typeof encodeURIComponent === 'undefined') {
    window.encodeURIComponent = typeof window.encodeURI === 'undefined' ? window.escape : window.encodeURI;
  }

  // this method was created to be able to disable
  // secure cookies for karma tests, dont use this for
  // other means.
  Cookie.setDisableSecureForTesting = function () {
    secure = false;
  };

  // thanks to the dev who initially added this, why could I not unset the expires?
  Cookie.setExpires = function (str) {
    if (typeof str === 'undefined') {
      expires = new Date().toString();
    } else {
      expires = str;
    }
    return expires;
  };

  // ###Cookie.parse([cookieString], cookieName, disableDecoding)
  // [optional] cookieString
  // [optional] cookieName
  // [optional] disableDecoding
  // description to follow
  // taken in part from YUI 3.4.1 _parseCookieString
  // addtion parse documentation goes here
  Cookie.parse = function (cookieString, cookieName, disableDecoding) {
    let j;
    const rmap = {};
    let cparts;
    let cname;
    let cvalue;

    // where we get the cookies
    const dc = cookieString || document.cookie;
    const cookies = dc.split(/;\s/g);
    const clen = cookies.length;
    // put all cookies in an object
    for (j = 0; j < clen; j += 1) {
      cparts = cookies[j].match(/([^=]+)=/i);
      try {
        if (cparts instanceof Array) {
          cname = decodeURIComponent(cparts[1]);
          if (cname === cookieName && disableDecoding) {
            cvalue = cookies[j].substring(cparts[1].length + 1);
          } else {
            cvalue = decodeURIComponent(cookies[j].substring(cparts[1].length + 1));
          }
        } else {
          cname = decodeURIComponent(cookies[j]);
          cvalue = '';
        }
        rmap[cname.replace(/ /g, '')] = cvalue;
      } catch (e) {
        // ignore it.
        Logger.warn('Error happened while parsing cookie string: ', cookies[j], e);
      }
    }
    return rmap;
  };

  // ###Cookie.get(name, [multiValueCookie], disableDecoding)
  // name the name of the cookie to get
  // [optional] multiValueCookie
  // [optional] disableDecoding
  Cookie.get = function (name, multiValueCookie, disableDecoding) {
    let result;
    let mvcParts;
    let plen;
    let j;
    let items;
    // hash will always be an object but may not have props
    const hash = this.parse('', name, disableDecoding);
    if (typeof multiValueCookie !== 'undefined') {
      if (hash[multiValueCookie]) {
        mvcParts = hash[multiValueCookie].split(MVC_SEPARATOR);
        plen = mvcParts.length;
        for (j = 0; j < plen; j++) {
          items = mvcParts[j].split(MVC_EQUATOR);
          if (items[0] === name) {
            result = items[1] === MVC_EMPTY_STRING ? '' : items[1];
            break;
          }
        }
      }
    } else {
      result = hash[name];
    }
    return result;
  };

  function buildMVCValue(multiValueCookie, name, value) {
    let mvcSubs;
    let j;
    let resultValue;
    let slen;
    let pairs;
    // get the whole multi value cookie
    const mvcValue = Cookie.get(multiValueCookie);
    const subCookie = name + MVC_EQUATOR + (value === '' ? MVC_SEPARATOR : value);
    if (!mvcValue || mvcValue === null) {
      // no cookie with the multiValueCookie name
      resultValue = subCookie;
    } else if (mvcValue.indexOf(name) === -1) {
      // multiValueCookie exists but the name value pair we want does not
      resultValue = mvcValue + MVC_SEPARATOR + subCookie;
    } else {
      // multiValueCookie exists and there is a sub cookie with that name
      mvcSubs = mvcValue.split(MVC_SEPARATOR);
      slen = mvcSubs.length;
      for (j = 0; j < slen; j++) {
        pairs = mvcSubs[j].split(MVC_EQUATOR);
        if (pairs[0] === name) {
          mvcSubs[j] = name + MVC_EQUATOR + value;
        }
      }
      resultValue = mvcSubs.join(MVC_SEPARATOR);
    }
    return resultValue;
  }

  // ###Method:
  // Will format a string to standard cookie domain values.  In particular, will take in string.  If none is passed in
  // then will attempt to pull domain value from configuration.
  // If it is passed in, then it will first check for at least two dots, and if found, return wild carded domain.
  Cookie.formatDomainForCookie = function (host) {
    let domain;
    let globalsBaseHost;
    if (typeof host === 'string' && host.length > 0) {
      if (host.indexOf('.', host.indexOf('.', 0) + 1) > 1) {
        domain = host.indexOf('.', 0) > 0 ? host.substring(host.indexOf('.', 0)) : host;
      } else {
        domain = '';
      }
    } else {
      globalsBaseHost = globals.getValue('props.cookieDomain');
      domain = typeof globalsBaseHost !== 'undefined' ? globalsBaseHost : undefined;
      if (typeof domain === 'undefined' || domain === null) {
        domain = Cookie.getHostName().replace(/(^(m|www[1]?))\./gi, '');
      }
    }
    // remove port for local testing
    domain = domain && domain.indexOf(':') !== -1 ? domain.substring(0, domain.indexOf(':')) : domain;
    return domain;
  };

  Cookie.getHostName = function () {
    return window.location.hostname;
  };

  // ###Cookie.set(name, value, [multiValueCookie], [options])
  // [optional] multiValueCookie, options
  // description to follow
  // >options - could be Date or object
  // >example: {expires: expiryDate, path: "/signin", domain: "fds.com", secure: true}
  Cookie.set = function (name, val, multiValueCookie, options) {
    let value = val;
    let data;
    let encodeValue;
    let setName = name;
    let localSecure;
    let localPath = path;
    const sameSite = 'Lax';
    let optionsSameSiteValue;

    value = typeof value === 'boolean' ? value.toString() : value;
    if (typeof value === 'undefined' || value === null) {
      if (!multiValueCookie) {
        return false;
      }
      // mvc cookie can have undefined or null value but it should be set to this
      value = MVC_EMPTY_STRING;
    }

    encodeValue = value;
    if (multiValueCookie) {
      setName = multiValueCookie;
      if (value === '') {
        value = MVC_EMPTY_STRING;
      }
      encodeValue = buildMVCValue(multiValueCookie, name, value);
    }

    data = `${encodeURIComponent(setName)}=${encodeURIComponent(encodeValue)}`;

    if (options) {
      // this is for backward compatibility
      if (options.constructor === Date) {
        expires = options.toGMTString();
      } else {
        // this is for new implementation
        if (options.expires) {
          expires = options.expires;

          if (expires.constructor === Date) {
            expires = expires.toGMTString();
          }
        }
        if (options.path) {
          localPath = options.path;
        }
        if (options.secure !== undefined) {
          localSecure = options.secure;
        }
      }
      optionsSameSiteValue = options.sameSite;
    }

    if (localSecure === undefined) {
      localSecure = secure;
    }

    if (expires) {
      data += `; expires=${expires}`;
    }
    data += `; path=${localPath}`;

    const domain = Cookie.formatDomainForCookie(options ? options.domain || '' : '');
    if (domain && domain.length) {
      data += `; domain=${domain}`;
    }
    if (localSecure) {
      data += `;secure=${localSecure}`;
    }

    // by default setting samesite attribute as Lax
    // if samesite is already set then setting the same value or else setting as lax
    // some Browsers dont support 'None' as value - esp Safari 13 in Mojave and previous,
    // for those cases , in UI , sameSite value is used as 'NoValue'
    if (optionsSameSiteValue !== 'NoValue') {
      data += `; SameSite=${optionsSameSiteValue || sameSite}`;
    }

    document.cookie = data;

    expires = null;

    return true;
  };

  // ###Cookie.remove(name, [multiValueCookie])
  // name the name of the cookie to remove
  // [optional] multiValueCookie
  Cookie.remove = function (name, multiValueCookie, options) {
    let mvcValue;
    let mvcSubs;
    let newValue;
    let j;
    let mvcParts;
    if (multiValueCookie) {
      mvcValue = this.get(multiValueCookie);
      if (mvcValue && mvcValue.indexOf(name) !== -1) {
        mvcSubs = mvcValue.split(MVC_SEPARATOR);
        newValue = '';
        for (j = 0; j < mvcSubs.length; j++) {
          mvcParts = mvcSubs[j].split(MVC_EQUATOR);
          if (mvcParts[0] !== name) {
            if (newValue !== '') {
              newValue += MVC_SEPARATOR;
            }
            newValue += mvcSubs[j];
          }
        }
        this.set(multiValueCookie, newValue, undefined, options);
      }
    } else {
      // set expires to yesterday
      expires = new Date(new Date().getTime() - 86400000);
      Cookie.set(name, '', undefined, options);
      expires = null;
    }
  };

  // ###Cookie.getCountryCode()
  // Will retun Shipping Country
  Cookie.getCountryCode = function () {
    let countryCode = Cookie.get('shippingCountry');
    if (!countryCode) {
      countryCode = null;
    }


    return countryCode;
  };

  // ###Cookie.getCountryCode()
  // Will return Currency Code
  Cookie.getCurrencyCode = function () {
    let currencyCode = Cookie.get('currency');
    if (!currencyCode) {
      currencyCode = null;
    }


    return currencyCode;
  };

  // ###Cookie.isInternationalMode()
  // Will return Boolean if is / isn't International Mode
  Cookie.isInternationalMode = function () {
    let isInternational = false;

    const shippingCountry = Cookie.getCountryCode();

    if (shippingCountry) {
      isInternational = shippingCountry !== 'US';
    }


    return isInternational;
  };

  // ###Cookie.getCustomerId()
  // Will return Customer Online UID if exsits or 0000000000 for testing purpose
  Cookie.getSessionId = function () {
    const sessionId = Cookie.get('bloomingdales_online_uid') || Cookie.get('macys_online_uid') || '0000000000';
    return sessionId;
  };

  // ###Cookie.getUserZipCode
  // will return user selected zipcode from MISCGCs cookie
  Cookie.getUserZipCode = function () {
    return Cookie.get('USERPC', 'MISCGCs');
  };

  module.exports = Cookie;
}
